import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class BreadcrumbProxyMapper extends Mapper {
  constructor({
    config,
    fromPageNameToTechnicalDetailsBreadcrumbVOMapper,
    fromPageNameToNewsBreadcrumbVOMapper,
    fromEmptyPageNameToDefaultBreadcrumbVOMapper,
    fromPageNameToAdsListBreadcrumbVOMapper,
    fromPageNameToLandingsBreadcrumbVOMapper,
    fromPageNameToModelDetailBreadcrumbVOMapper
  }) {
    super()

    this._config = config
    this._fromPageNameToTechnicalDetailsBreadcrumbVOMapper = fromPageNameToTechnicalDetailsBreadcrumbVOMapper
    this._fromPageNameToNewsBreadcrumbVOMapper = fromPageNameToNewsBreadcrumbVOMapper
    this._fromEmptyPageNameToDefaultBreadcrumbVOMapper = fromEmptyPageNameToDefaultBreadcrumbVOMapper
    this._fromPageNameToAdsListBreadcrumbVOMapper = fromPageNameToAdsListBreadcrumbVOMapper
    this._fromPageNameToLandingsBreadcrumbVOMapper = fromPageNameToLandingsBreadcrumbVOMapper
    this._fromPageNameToModelDetailBreadcrumbVOMapper = fromPageNameToModelDetailBreadcrumbVOMapper
  }

  createFor = ({pageName, params}) => {
    const {
      ADS_LIST_PAGE_NAME,
      ADS_LIST_BUGGIES_PAGE_NAME,
      ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME,
      ADS_LIST_MINIMOTOS_PAGE_NAME,
      ADS_LIST_QUADS_PAGE_NAME,
      ADS_LIST_NEW_PAGE_NAME,
      ADS_LIST_BUGGIES_NEW_PAGE_NAME,
      ADS_LIST_MINIMOTOS_NEW_PAGE_NAME,
      ADS_LIST_QUADS_NEW_PAGE_NAME,
      ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME,
      ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME,
      ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME,
      LANDING_FINANCING_PAGE_NAME,
      LANDING_FORMALITIES_PAGE_NAME,
      LANDING_FORMALITIES_SECURITY_GUIDELINES_PAGE_NAME,
      MAKE_PAGE_NAME,
      MAKES_DISTRIBUTOR_PAGE_NAME,
      MAKES_SIZES_DISTRIBUTOR_PAGE_NAME,
      MODEL_DETAIL_PAGE_NAME,
      MODEL_DETAIL_INTERIOR_PAGE_NAME,
      MODEL_DETAIL_TRUNK_PAGE_NAME,
      MODEL_SIZES_PAGE_NAME,
      TECHNICAL_DETAILS_HOME_PAGE_NAME,
      TECHNICAL_DETAILS_COMPARATOR_PAGE_NAME,
      TECHNICAL_DETAILS_COMPARATOR_RESULTS_PAGE_NAME,
      TECHNICAL_DETAILS_MAKE_PAGE_NAME,
      TECHNICAL_DETAILS_MODEL_PAGE_NAME,
      TECHNICAL_DETAILS_BODY_TYPE_PAGE_NAME,
      TECHNICAL_DETAILS_VERSION_PAGE_NAME,
      TECHNICAL_DETAILS_VEHICLE_PAGE_NAME,
      TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PAGE_NAME,
      TECHNICAL_DETAILS_SEARCH_PAGE_NAME,
      TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME,
      NEWS_CATEGORY_PAGE_NAME,
      NEWS_SEARCH_PAGE_NAME,
      NEWS_TAG_PAGE_NAME,
      NEWS_SECTION_TIPS_PAGE_NAME,
      NEWS_SECTION_TRENDS_PAGE_NAME,
      VEHICLE_APPRAISER_PAGE_NAME
    } = this._config.get('page')
    switch (pageName) {
      case ADS_LIST_PAGE_NAME:
      case ADS_LIST_BUGGIES_PAGE_NAME:
      case ADS_LIST_MINIMOTOS_PAGE_NAME:
      case ADS_LIST_QUADS_PAGE_NAME:
      case ADS_LIST_NEW_PAGE_NAME:
      case ADS_LIST_BUGGIES_NEW_PAGE_NAME:
      case ADS_LIST_MINIMOTOS_NEW_PAGE_NAME:
      case ADS_LIST_QUADS_NEW_PAGE_NAME:
      case ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME:
      case ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME:
      case ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME:
      case ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME:
        return this._fromPageNameToAdsListBreadcrumbVOMapper.map({
          ...params
        })
      case LANDING_FINANCING_PAGE_NAME:
      case LANDING_FORMALITIES_PAGE_NAME:
      case LANDING_FORMALITIES_SECURITY_GUIDELINES_PAGE_NAME:
      case VEHICLE_APPRAISER_PAGE_NAME:
        return this._fromPageNameToLandingsBreadcrumbVOMapper.map({
          pageName,
          ...params
        })
      case MAKE_PAGE_NAME:
      case MAKES_DISTRIBUTOR_PAGE_NAME:
      case MAKES_SIZES_DISTRIBUTOR_PAGE_NAME:
      case MODEL_DETAIL_PAGE_NAME:
      case MODEL_DETAIL_INTERIOR_PAGE_NAME:
      case MODEL_DETAIL_TRUNK_PAGE_NAME:
      case MODEL_SIZES_PAGE_NAME:
        return this._fromPageNameToModelDetailBreadcrumbVOMapper.map({
          pageName,
          ...params
        })
      case TECHNICAL_DETAILS_HOME_PAGE_NAME:
      case TECHNICAL_DETAILS_COMPARATOR_PAGE_NAME:
      case TECHNICAL_DETAILS_COMPARATOR_RESULTS_PAGE_NAME:
      case TECHNICAL_DETAILS_MAKE_PAGE_NAME:
      case TECHNICAL_DETAILS_MODEL_PAGE_NAME:
      case TECHNICAL_DETAILS_BODY_TYPE_PAGE_NAME:
      case TECHNICAL_DETAILS_VERSION_PAGE_NAME:
      case TECHNICAL_DETAILS_VEHICLE_PAGE_NAME:
      case TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PAGE_NAME:
      case TECHNICAL_DETAILS_SEARCH_PAGE_NAME:
      case TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME:
        return this._fromPageNameToTechnicalDetailsBreadcrumbVOMapper.map({
          pageName,
          ...params
        })
      case NEWS_CATEGORY_PAGE_NAME:
      case NEWS_SEARCH_PAGE_NAME:
      case NEWS_TAG_PAGE_NAME:
      case NEWS_SECTION_TIPS_PAGE_NAME:
      case NEWS_SECTION_TRENDS_PAGE_NAME:
        return this._fromPageNameToNewsBreadcrumbVOMapper.map({
          pageName,
          params
        })
      default:
        return this._fromEmptyPageNameToDefaultBreadcrumbVOMapper.map()
    }
  }
}
